import { defineStore } from 'pinia';
import { strapi } from '~/stores/transport/strapi';
import { type IStrapiImage } from '~/types/strapiImage';
import { assignDataToFields, createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import type { IStrapiBanner } from '~/types/banners';

export const useStoreModalAuth = defineStore('modalAuth', {
  state: () => ({
    signUpTitle: '',
    logInTitle: '',

    signUpStep1Title: '',
    signUpStep2Title: '',
    signUpStep3Title: '',
    signUpStep4Title: '',

    emailTitle: '',
    passwordTitle: '',
    currencyTitle: '',
    termsTitle: '',
    termsLinkTitle: '',
    receivePromoTitle: '',
    bonusCodeTitle: '',
    bonusCodeOpenTitle: '',
    maleTitle: '',
    femaleTitle: '',
    twoFaTitle: '',
    twoFaCodeTitle: '',
    newPasswordTitle: '',
    repeatPasswordTitle: '',

    forgotTitle: '',
    forgotSuccessTitle: '',
    forgotSuccessMessage: '',

    unlockTitle: '',
    unlockSuccessTitle: '',
    unlockSuccessMessage: '',

    restrictedSignupTitle: '',
    restrictedSignupText: '',
    vpnName: '',
    restrictedSignupIcon: {} as IStrapiImage,

    resetTitle: '',
    resetSuccessTitle: '',
    resetSuccessMessage: '',

    bannerText: '',
    haveAnAccountTitle: '',
    registerInfoText: '',
    haveNoAccountTitle: '',
    signUpGoogleTitle: '',
    logInGoogleTitle: '',
    dividerTitle: '',
    btcRegistrationStags: '',
    promoTooltipText: '',
    partnerpromotionsTooltipText: '',
    crossSaleTitle: '',
    showPromotionsCheckbox: false,
    banner: {} as IStrapiBanner,
    locale: '',
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadAuthModal() {
      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'banner',
          'banner.desktopAssetFront',
          'banner.desktopAssetBack',
          'banner.mobileAsset',
          'restrictedSignupIcon',
        ]);

        this.requestPromise = strapi()
          .get('auth-modal', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
